import { useQuery } from '@tanstack/react-query';
import {
  getCrawlerAnalyticsStats,
  getCrawlerAccessLogs,
} from '../services/api';
import type {
  CrawlerAnalyticsStats,
  CrawlerAccessLogsResponse,
} from '../types';

/**
 * F4.3: Crawler analytics hooks — TanStack React Query wrappers.
 */

/** Fetch aggregated crawler access stats. */
export function useCrawlerAnalyticsStats(days = 30) {
  return useQuery<CrawlerAnalyticsStats>({
    queryKey: ['crawler-analytics-stats', days],
    queryFn: () => getCrawlerAnalyticsStats(days),
    staleTime: 60_000,
    retry: false,
  });
}

/** Fetch recent crawler access logs (paginated). */
export function useCrawlerAccessLogs(limit = 50, offset = 0) {
  return useQuery<CrawlerAccessLogsResponse>({
    queryKey: ['crawler-analytics-logs', limit, offset],
    queryFn: () => getCrawlerAccessLogs(limit, offset),
    staleTime: 30_000,
    retry: false,
  });
}
